export default "__VITE_PUBLIC_ASSET__1989716d__"